import { render, staticRenderFns } from "./FileChooserTable.vue?vue&type=template&id=16cafc51&"
import script from "./FileChooserTable.vue?vue&type=script&lang=js&"
export * from "./FileChooserTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports